import React from 'react';
import './TabNavigation.css';
import { User } from '@supabase/supabase-js';

interface TabNavigationProps {
  activeTab: 'zoning' | 'analysis';
  onTabChange: (tab: 'zoning' | 'analysis') => void;
  user: User | null;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange, user }) => {
  const handleTabClick = (tab: 'zoning' | 'analysis') => {
    onTabChange(tab);
  };

  return (
    <div className="tab-navigation">
      <button 
        className={`tab-button ${activeTab === 'zoning' ? 'active' : ''}`}
        onClick={() => handleTabClick('zoning')}
      >
        Property
      </button>
      <button 
        className={`tab-button ${activeTab === 'analysis' ? 'active' : ''}`}
        onClick={() => handleTabClick('analysis')}
      >
        Analysis
      </button>
    </div>
  );
};

export default TabNavigation;
